import { useTranslation } from 'react-i18next'
import { VpSticker } from '@vtmn-play/react'

const isGood = (value: string) => {
  return value === 'GOOD'
}

interface YearlyGraphBadgeProps {
  yearToDateEvaluation: string
  yearEvaluation: string
}

const YearlyGraphBadge = ({ yearToDateEvaluation = null, yearEvaluation = null }: YearlyGraphBadgeProps) => {
  const { t } = useTranslation()

  const isBadgeStatusAvailable = yearToDateEvaluation != null && yearEvaluation != null
  const isBadgeStatusGood = isGood(yearToDateEvaluation) && isGood(yearEvaluation)

  return (
    <span data-testid="yearly-graph-badge">
      {isBadgeStatusAvailable && (
        <VpSticker
          {...({ variant: 'catchy', size: 'small' } as any)}
          className={`yearly-badge ${isBadgeStatusGood ? 'status-good' : 'status-bad'}`}
        >
          {isBadgeStatusGood ? t('general.cumulative_charts.badge.good') : t('general.cumulative_charts.badge.at_risk')}
        </VpSticker>
      )}
    </span>
  )
}

export default YearlyGraphBadge
